// ABOUTME: The error codes of the interview routes (docs/interviews/error-codes.md in pro-core) turned into the copy the
// ABOUTME: talent reads; a code with no line of its own gets the honest generic one.
import { TranslationKey } from 'modules/i18n';
import { ApiError } from 'utils/api';
import { INTERVIEW_UNKNOWN_ERROR_CODE } from './constants';

const ERROR_COPY: Record<string, TranslationKey> = {
  'error.interview.not-found': 'interviews.error.notFound',
  'error.interview.unavailable': 'interviews.error.unavailable',
  'error.interview.session-expired': 'interviews.error.sessionExpired',
  'error.interview.time-not-available': 'interviews.error.timeNotAvailable',
  'error.interview.hold-expired': 'interviews.error.holdExpired',
  'error.interview.move-limit': 'interviews.error.moveLimit',
  'error.interview.too-late-to-move': 'interviews.error.tooLateToMove',
  'error.interview.not-open': 'interviews.error.notOpen',
  'error.interview.not-scheduled': 'interviews.error.notScheduled',
  'error.interview.time-options-invalid': 'interviews.error.timeOptionsInvalid',
  'error.interview.room-closed': 'interviews.error.roomClosed',
  'error.interview.not-a-no-show': 'interviews.error.notANoShow',
  'error.parameters.not-valid': 'interviews.error.parametersInvalid',
  'error.parameter.invalid': 'interviews.error.parametersInvalid'
};

export const interviewErrorCode = (error: unknown): string =>
  error instanceof ApiError ? error.code : INTERVIEW_UNKNOWN_ERROR_CODE;

export const interviewErrorKey = (error: unknown): TranslationKey =>
  ERROR_COPY[interviewErrorCode(error)] ?? 'interviews.error.unknown';
